import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import env_constants from '../Constants';
import { useCart } from '../Context/CartContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import _ from 'lodash';  // Import lodash

const ProductCard = ({ product, categories = [], badge, className }) => {
    const { dispatch } = useCart();

    const categoryTitle = categories.find(category => category.id === product.category_id)?.title;
    const originalPrice = parseFloat(product?.product_meta?.find(meta => meta.option === '_price')?.value || 0);
    const discountValue = parseFloat(product?.discount_data?.discount_value || 0);
    const discountType = parseInt(product?.discount_data?.discount_type, 10);
    const productimagenotfound = '/assets/images/product-image-not-found.webp';


    let discountedPrice = originalPrice;
    let discountDisplay = '';

    if (discountValue) {
        if (discountType === 0) {
            discountDisplay = `Save ${discountValue}%`;
            discountedPrice -= (originalPrice * (discountValue / 100));
        } else if (discountType === 1) {
            discountDisplay = `Save $${discountValue}`;
            discountedPrice -= discountValue;
        }
    }



    // Throttle the handleAddToCart function
    const handleAddToCart = useCallback(
        _.throttle(() => {
            const productWithDefaultQuantity = { ...product, quantity: 1 };
            dispatch({ type: 'ADD_TO_CART', payload: productWithDefaultQuantity });

            toast.success(`${product.title} added to cart!`, {
                position: "top-right",
                autoClose: 3000, // 3 seconds
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                style: {
                    color: "black",
                    fontWeight: "bold"
                },
                toastStyle: {
                    backgroundColor: "red",
                },
                iconTheme: {
                    primary: "red",
                }
            });
        }, 1000), [product, dispatch]
    );

    return (
        <div className={`product-card position-relative ${className}`}>
            {discountValue > 0 && (
                <span className="product-sale-tag">
                    {discountDisplay}
                </span>
            )}
            <ul className="product-features">
                <li><a href="/" className="product-wishlist"><i></i></a></li>
            </ul>
            <img
                src={`${env_constants.API_BASE_PUBLIC_URL}${product.featured_image}`}
                onError={(e) => e.target.src = productimagenotfound}
                alt={product.title}
                className="team-member-thumbnail"
            />

            <h5 className="product-category">{categoryTitle}</h5>
            <h3 className="product-title">
                <Link to={`/product/${encodeURIComponent(product.permalink)}`}>{product.title}</Link>
            </h3>
            <p className="product-price">
                ${discountedPrice.toFixed(2)}
                {discountValue > 0 && (<span className="original-price">${originalPrice.toFixed(2)}</span>)}
            </p>
            <button className="add-cart-btn" type="button" onClick={handleAddToCart}>Add to Cart</button>
        </div>
    );
};

export default ProductCard;
<ToastContainer />
